import type { LiveModalStep } from '../../components/master/creatorModalsShared';

export const nextOfflineEventStep = (
  step: LiveModalStep,
  screenMode: boolean,
): LiveModalStep => screenMode && step === 'edit' ? 'design' : 'preview';

export const previousOfflineEventStep = (
  step: LiveModalStep,
  screenMode: boolean,
): LiveModalStep => screenMode && step === 'preview' ? 'design' : 'edit';
